import { defineAction } from '~/prix'
import { z } from 'zod'
import residenceGeocodeAction from './generalResidenceGeocode.action.json'

const residenceGeocodeDefinition = defineAction({
  ...residenceGeocodeAction,
  input: z.object({
    dataSourceIdentifiers: z.array(z.number().int()).optional(),
    residenceOriginalIdentifiers: z.array(z.string().min(1)).optional(),
    debug: z.boolean().optional(),
    testOnly: z.boolean().optional(),
    sourceWhere: z.string().nullish(),
    geocodeWhere: z.string().nullish(),
  }),
  output: z.object({
    metrics: z.object({
      sourceResidenceRows: z.number(),
      currentUsableRows: z.number(),
      operationalCoordinates: z.object({
        rows: z.number(),
        distinctKeys: z.number(),
        invalidCoordinates: z.number(),
        missingSourceKey: z.number(),
        orphanedFromResidenceProfile: z.number(),
        protectedWithoutChanges: z.number(),
        candidates: z.number(),
        reverseGeocodingSucceeded: z.number(),
        reverseGeocodingFailed: z.number(),
        written: z.number(),
      }),
      automaticGeocoding: z.object({
        protectedByOperationalCoordinates: z.number(),
        protectedByDestinationManualCoordinates: z.number(),
        protectedByValidatedGeocoding: z.number(),
        promotedFromCachedGeocoding: z.number(),
        cachedRejected: z.number(),
        attempted: z.number(),
        skippedWithoutAddress: z.number(),
        accepted: z.number(),
        rejectedInvalidCoordinates: z.number(),
        rejectedQuality: z.number(),
        rejectedUnresolvedSourceMunicipality: z.number(),
        rejectedMunicipalityMismatch: z.number(),
        written: z.number(),
        resultsByQuality: z.record(z.number()),
      }),
      projectedUsableRows: z.number(),
      finalUsableRows: z.number(),
    }),
  }),
})

export default residenceGeocodeDefinition
